import CONFIG from '../../../config';

// This function is used to upload the onboarding prompt from www.workflow86.com to the S3 bucket
// For subsequent retrieval during sign up in @ChatActions.jsx (if no prompt - default options will render)

const uploadOnboardingPrompt = async (pendingPrompt, email) => {
  const formData = new FormData();
  const blob = new Blob([pendingPrompt], { type: 'text/plain' });
  formData.append('key', `${email}.txt`);
  formData.append('file', blob, `${email}.txt`);

  const uploadUrl = `https://${CONFIG.AWS.S3_ONBOARDING_PROMPTS_BUCKET}.s3.${CONFIG.AWS.REGION}.amazonaws.com/`;

  const response = await fetch(uploadUrl, {
    method: 'POST',
    mode: 'cors',
    headers: {
      Origin: window.location.origin,
    },
    body: formData,
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error('Upload failed:', errorText);
  } else {
    console.log('Successfully uploaded prompt for:', email);
  }
};

export default uploadOnboardingPrompt;
